
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.542 15.545H18.455V2.458C18.455 1.668 17.803 1 17 1c-.78 0-1.455.653-1.455 1.458v13.087H2.458C1.668 15.545 1 16.197 1 17c0 .78.653 1.455 1.458 1.455h13.087v13.087c0 .79.652 1.458 1.455 1.458.78 0 1.455-.653 1.455-1.458V18.455h13.087c.79 0 1.458-.652 1.458-1.455 0-.78-.653-1.455-1.458-1.455z"}})])
          )
        }
      }
    